import React, { useState, useMemo, useContext } from "react";
import { IconButton, Menu, MenuItem,List,ListItem,ListItemIcon,ListItemText,Collapse } from "@mui/material";
import { LocaleContext } from "../LocaleContext";

export const OverflowMenuProvider = {};

export default function OverflowMenu({ children, className, visibilityMap }) {
  const { t } = useContext(LocaleContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  OverflowMenuProvider.setVisible = setAnchorEl;

  const overflowChildCount = useMemo(() => {
    let count = 0;
    React.Children.forEach(children, (child) => {
      if (child == null || !React.isValidElement(child) || !child.props) return;
      const targetId = child.props["data-targetid"];
      if (!targetId || targetId === "vert") return;
      if (visibilityMap[targetId] === false) count += 1;
    });
    return count;
  }, [children, visibilityMap]);

  if (overflowChildCount === 0) {
    return null;
  }
  return (
    <div className={className} data-overflow-trigger>
      <IconButton
        aria-label={t('Common.More')}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className="w-5"
      >
        <i className="pi pi-ellipsis-v"></i>
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        {React.Children.map(children, (child) => {
          if (child == null || !React.isValidElement(child) || !child.props) {
            return null;
          }
          if (visibilityMap[child.props["data-targetid"]] === false) {
            if(child.props["data-targetid"]=="vert"){
                return null
            }
            if(child.props["data-targetid"]=="actions"){
              /*return (
                <div className="card flex justify-content-center z-[100] bg-zinc-800" data-targetid="actions">
                  <PanelMenu model={items} className="w-full md:w-20rem" />
                </div>
              );*/
              return React.cloneElement(child,child.props);
            }
            return (
              <MenuItem key={child} onClick={handleClose}>
                {React.cloneElement(child,child.props)}
              </MenuItem>
            );
          }
          return null;
        })}
      </Menu>
    </div>
  );
}
